"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rdf = exports._ontologyResource = void 0;
/*
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
const models_1 = require("../models");
const Prefix_1 = require("../utils/Prefix");
var base = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#';
exports._ontologyResource = models_1.NamedNode.getOrCreate(base);
Prefix_1.Prefix.add('rdf', base);
var langString = models_1.NamedNode.getOrCreate(base + 'langString');
var type = models_1.NamedNode.getOrCreate(base + 'type');
var Property = models_1.NamedNode.getOrCreate(base + 'Property');
var List = models_1.NamedNode.getOrCreate(base + 'List');
var rest = models_1.NamedNode.getOrCreate(base + 'rest');
var first = models_1.NamedNode.getOrCreate(base + 'first');
var nil = models_1.NamedNode.getOrCreate(base + 'nil');
exports.rdf = {
    _ontologyResource: exports._ontologyResource,
    langString,
    type,
    Property,
    List,
    rest,
    first,
    nil,
};
//# sourceMappingURL=rdf.js.map